import { AircraftCategory, AircraftType } from '@flyblack/common/domains';

import { authorizedApi } from '../network/authorized-api';

export const getAircraftType = (id: number) => authorizedApi.get<AircraftType>(`/v1/aircraft-types/${id}`);

export const getAircraftCategories = () =>
  authorizedApi.get<{ categories: AircraftCategory[] }>(`/v1/aircraft-categories`);
